import { useCallback, useContext, useState } from 'react'

import { Text, Loader } from '@cash-me/react-components'

import { billsClient } from 'src/adapters/http'

import { DuplicateBillContext } from '..'
import type { DuplicateBillContextProps } from '../types'

import { ResentTokenComponent } from './fragments/ResendToken'
import { TokenFieldComponent } from './fragments/TokenFieldComponent'
import * as S from './styles'

export const MfaCode = () => {
  const { fields, changeCallback, routeCallback } = useContext<DuplicateBillContextProps>(DuplicateBillContext)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const handleFilledToken = async (code: string) => {
    setIsLoading(true)

    await billsClient
      .getSecondCopyBill({
        contrato: fields.contract,
        documento: fields.document,
        idMfa: fields.mfaId,
        codigoMfa: code
      })
      .then(({ data }) => {
        changeCallback('pdfId', data.idBoleto)
        routeCallback('info', {
          type: 'success'
        })
      })
      .catch(error => {
        const status = (error as { response: { status: number } }).response?.status
        if (status === 400) {
          setErrorMessage('O código está incorreto. Verifique e tente novamente.')
        } else {
          let boxType = 'server-error'
          if (status === 404) boxType = 'no-bill'
          if (status === 402) boxType = 'error'

          routeCallback('info', {
            type: boxType
          })
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage('')
  }

  const resendToken = useCallback(async () => {
    await billsClient
      .getMFA({
        contrato: fields.contract,
        documento: fields.document,
        tipo: fields.mfaSelectedOption
      })
      .then(({ data }) => changeCallback('mfaId', data.id))
      .catch(() =>
        routeCallback('info', {
          type: 'server-error'
        })
      )
  }, [changeCallback, routeCallback, fields])

  return (
    <S.Form>
      <Text size="heading5" weight="medium" color="var(--colors-neutral-text-default)">
        Digite o código que recebeu:
      </Text>
      <Text size="body1" color="var(--colors-neutral-text-default)">
        O código pode demorar alguns segundos para chegar. Aguarde.
      </Text>
      <S.FieldWrapper>
        <TokenFieldComponent
          onFilledToken={handleFilledToken}
          clearErrorMessage={clearErrorMessage}
          {...(errorMessage && { errorMessage })}
        />
        {isLoading && (
          <S.LoaderWrapper>
            <Loader size="lg" />
            <Text size="caption">Por favor, aguarde...</Text>
          </S.LoaderWrapper>
        )}
        <ResentTokenComponent showComponent={!isLoading} onResendTokenClick={() => resendToken()} />
      </S.FieldWrapper>

      {!isLoading && (
        <S.BackButtonWrapper>
          <S.Link onClick={() => routeCallback('mfa-options')}>
            <Text size="body1" weight="medium" color="var(--colors-blue-text-default)">
              Voltar
            </Text>
          </S.Link>
        </S.BackButtonWrapper>
      )}
    </S.Form>
  )
}
